import Joi from '@hapi/joi'

export const collectionpointMonthlyDetailReportSchema = {
    groupID: Joi.number().invalid(0).required().label("Group").messages({
        "any.invalid": `Please select valid Group`,
        "any.required": `Group required`
    }),
    operationEntityID: Joi.number().invalid(0).required().label("Operatin Entity").messages({
        "any.invalid": `Please select valid Operatin Entity`,
        "any.required": `Operatin Entity required`
    }),
    fromDate: Joi.string().invalid("").label("From Date"),
    toDate: Joi.string().invalid("").label("To Date"),
    collectionCategoryID: Joi.number().invalid(0).required().label("Collectioncatagory").messages({
        "string.empty": `Collectioncatagory required`,
        "string.pattern.base": `Please enter valid Collectioncatagory`,
    }),
    collectionPointID: Joi.number().invalid(0).required().label("Collectionpoint").messages({
        "any.invalid": `Please select valid Collectionpoint`,
        "any.required": `Collectionpoint required`
    }),
}